import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";
import clubInfo from "../club_info.json"
import PageTitlesBig from "./PageTitlesBig";
import PageTitlesSM from "./PageTitlesSM";


const ActividadesDetalle = () => {
    const navigate = useNavigate();
    var datosLugar = clubInfo.filter((x) => { return (x.id == localStorage.getItem("Actividad-Club"))});
    console.log("DATIDOS");
    console.log(datosLugar[0]);
    console.log("DATIDOS-END");
    const actionClick = (activ) => {
        localStorage.setItem("Actividad-Tipo", activ);
        navigate("/actividadiframe");
    }
    
    return (
        <>
        <main>
      <div class="container text-center mainContent" >
        <PageTitlesSM texto="Clubes Municipales"  icono="./icon_header_clubes.svg" retorno="/actividades" subtexto={"Club "+localStorage.getItem("Actividad-Club")}/>
        {/*<PageTitlesBig texto="Clubes Municipales"  icono="./icon_header_clubes.svg" retorno="/actividades" subtexto={"Club "+localStorage.getItem("Actividad-Club")}/>*/}
    
    <div class="row">
        <div class="col alignJustify clubText">
        {  clubInfo.filter((x) => { return (x.id == localStorage.getItem("Actividad-Club"))}).map(x => {return x.texto})
        }

        </div>
        </div>
        <div class="row" style={{paddingTop:"30px"}}>
                <div class="col">
                    <div className="buttonContainer">
                        <button className="buttonEstacionamientoClip" onClick={()=>actionClick("Register")}>Me quiero registrar</button>
                    </div>
                </div>
            </div>
            {
                datosLugar[0].link_calendario==""?"":
            <div class="row">
            <div class="col">
                <div className="buttonContainer">
                    <button className="buttonEstacionamientoClip"  onClick={()=>actionClick("Calendar")}>Calendario</button>
                </div>
            </div>
            </div>
            } 
           {datosLugar[0].link_video==""?"":
            <div class="row">
            <div class="col">
                <div className="buttonContainer">
                    <button className="buttonEstacionamientoClip" onClick={()=>actionClick("Video")}>Ver Video</button>
                </div>
            </div>
        </div>}
    
</div>
</main>
        
        </>

    );
    }
export default ActividadesDetalle;